import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

export default function Transit (props) {
  useEffect(() => {
  }, [])

  return props.inTransit
    ? (
    <div className="d-flex justify-content-center">
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
      )
    : props.element
}

Transit.propTypes = {
  element: PropTypes.element,
  inTransit: PropTypes.bool
}
